export default "__VITE_PUBLIC_ASSET__b38b95a5__"